<template>
    <div class="gifts-container">
        <GiftDropdown v-if="is_dropdown" :gifts="gifts"></GiftDropdown>
        <GiftRadio v-else :gifts="gifts"></GiftRadio>
    </div>
</template>


<script>
import mixin from "../../../travel_step_mixin";
import GiftDropdown from "./GiftDropdown.vue";
import GiftRadio from "./GiftRadio.vue";
import image_mixin from "../../../../../../views/_commons/fr/mixins/image_mixin";

export default {
    components: {GiftDropdown, GiftRadio},
    mixins: [mixin, image_mixin],
    props: {
        is_dropdown: [Boolean, String],
    },
    data() {
        return {
            gifts: {},
        };
    },
    mounted() {
        this.gifts = this.gift_choice;
    },
    created() {
        this.step._field_name = this.field_name;
    },
};


</script>


